import React from 'react';

import AdminSettingsDocumentDataViewController from './view-document-data.controller';

const AdminSettingsDocumentDataViewScreen = () => {
  return <AdminSettingsDocumentDataViewController />;
};

export default AdminSettingsDocumentDataViewScreen;
